import React from "react";

// TL Iscilik formulu icin sabit HAS degerleri (backend ile birebir ayni - utils/prices.py)
const TL_ISCILIK_FIXED = {
  ceyrek:   { alis: 1.596,  satis: 1.606 },
  yarim:    { alis: 3.192,  satis: 3.210 },
  teklik:   { alis: 6.384,  satis: 6.420 },
  ata_lira: { alis: 6.566,  satis: 6.610 },
  gremse:   { alis: 15.960, satis: 16.060 },
};

const STATUS_BADGE = {
  verified: { color: "#22c55e", icon: "✅", label: "Doğrulandı" },
  suspicious: { color: "#f59e0b", icon: "⚠️", label: "Şüpheli" },
  failed: { color: "#ef4444", icon: "❌", label: "Başarısız" },
  default: { color: "#6b7280", icon: "•", label: "Bekleniyor" },
  manual: { color: "#3b82f6", icon: "✏️", label: "Manuel" },
};

const fmtPct = (n) => `${(n || 0).toFixed(2)}%`;

/**
 * Sarrafiye carpan tablosu + formul tipi (Carpan+Marj veya TL Iscilik) + Manuel/Otomatik toggle
 */
const SarrafiyeCarpanTable = ({
  carpan,
  sarrafiyeList,
  isAutoMode,
  formulaType,
  inputStyle,
  inputDisabled,
  colHeader,
  onToggleMode,
  onSetFormulaType,
  onUpdateField,
  onSave,
}) => (
  <div style={{ background: "#e4e4e4", borderRadius: 12, padding: 16, marginBottom: 14, boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, flexWrap: "wrap", gap: 10 }}>
      <h3 style={{ margin: 0, color: "#09301E", fontSize: 15 }}>📊 Sarrafiye Çarpanları</h3>
      <div style={{ display: "flex", gap: 5 }}>
        <button onClick={() => onToggleMode("auto")} data-testid="ak-mode-auto-btn"
          style={{ padding: "7px 12px", fontSize: 11, fontWeight: 700, borderRadius: 6, background: isAutoMode ? "#22c55e" : "#e5e7eb", color: isAutoMode ? "#fff" : "#475569", border: "none", cursor: "pointer" }}>Otomatik</button>
        <button onClick={() => onToggleMode("manual")} data-testid="ak-mode-manual-btn"
          style={{ padding: "7px 12px", fontSize: 11, fontWeight: 700, borderRadius: 6, background: !isAutoMode ? "#3b82f6" : "#e5e7eb", color: !isAutoMode ? "#fff" : "#475569", border: "none", cursor: "pointer" }}>Manuel</button>
      </div>
    </div>

    {/* Hesap Türü segmented */}
    <div style={{ display: "flex", gap: 0, marginBottom: 10, background: "#f1f5f9", padding: 4, borderRadius: 8, width: "fit-content" }}>
      <button onClick={() => onSetFormulaType("carpan")} data-testid="ak-formula-carpan-btn"
        style={{ padding: "8px 16px", fontSize: 12, fontWeight: 700, borderRadius: 6, border: "none", cursor: "pointer",
                 background: formulaType === "carpan" ? "#DA9F54" : "transparent", color: formulaType === "carpan" ? "#000" : "#475569" }}>
        Çarpan + Marj
      </button>
      <button onClick={() => onSetFormulaType("tl_iscilik")} data-testid="ak-formula-tliscilik-btn"
        style={{ padding: "8px 16px", fontSize: 12, fontWeight: 700, borderRadius: 6, border: "none", cursor: "pointer",
                 background: formulaType === "tl_iscilik" ? "#DA9F54" : "transparent", color: formulaType === "tl_iscilik" ? "#000" : "#475569" }}>
        TL İşçilik
      </button>
    </div>

    <p style={{ fontSize: 11, color: "#64748b", margin: "0 0 8px" }}>
      {formulaType === "tl_iscilik"
        ? <>Formül: <code style={{ background: "#fef3c7", padding: "1px 6px", borderRadius: 3 }}>Çarpan × HAS + İşçilik + Marj</code></>
        : <>Formül: <code style={{ background: "#fef3c7", padding: "1px 6px", borderRadius: 3 }}>Çarpan × HAS + Marj</code></>
      }
    </p>

    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, minWidth: formulaType === "tl_iscilik" ? 950 : 750 }}>
        <thead>
          <tr>
            <th style={{ ...colHeader, textAlign: "left" }}>Ürün</th>
            <th style={colHeader}>Alış Çarpan</th>
            <th style={colHeader}>Satış Çarpan</th>
            {formulaType === "tl_iscilik" && (
              <>
                <th style={colHeader}>Alış İşçilik</th>
                <th style={colHeader}>Satış İşçilik</th>
              </>
            )}
            <th style={colHeader}>Alış Marj</th>
            <th style={colHeader}>Satış Marj</th>
            <th style={colHeader}>Durum</th>
          </tr>
        </thead>
        <tbody>
          {sarrafiyeList.map(s => {
            const c = carpan[s.key] || {};
            const status = STATUS_BADGE[c.last_status] || STATUS_BADGE.default;
            const isTl = formulaType === "tl_iscilik";
            const tlAutoLocked = isTl && isAutoMode;
            const fixedAlis = tlAutoLocked ? TL_ISCILIK_FIXED[s.key].alis : null;
            const fixedSatis = tlAutoLocked ? TL_ISCILIK_FIXED[s.key].satis : null;
            return (
              <tr key={s.key} style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "8px 6px", fontWeight: 700, color: "#09301E" }}>{s.label}</td>
                <td style={{ padding: 4 }}>
                  <input type="text" inputMode="decimal"
                    value={tlAutoLocked ? fixedAlis : (c.alis_carpan ?? "")}
                    onChange={e => onUpdateField(s.key, "alis_carpan", e.target.value)}
                    readOnly={isAutoMode}
                    title={tlAutoLocked ? "TL İşçilik Otomatik — sabit HAS değeri" : undefined}
                    style={isAutoMode ? inputDisabled : inputStyle} data-testid={`ak-${s.key}-alis-carpan`} />
                </td>
                <td style={{ padding: 4 }}>
                  <input type="text" inputMode="decimal"
                    value={tlAutoLocked ? fixedSatis : (c.satis_carpan ?? "")}
                    onChange={e => onUpdateField(s.key, "satis_carpan", e.target.value)}
                    readOnly={isAutoMode}
                    title={tlAutoLocked ? "TL İşçilik Otomatik — sabit HAS değeri" : undefined}
                    style={isAutoMode ? inputDisabled : inputStyle} data-testid={`ak-${s.key}-satis-carpan`} />
                </td>
                {formulaType === "tl_iscilik" && (
                  <>
                    <td style={{ padding: 4 }}>
                      <input type="text" inputMode="decimal" value={c.alis_iscilik ?? ""} onChange={e => onUpdateField(s.key, "alis_iscilik", e.target.value)} style={inputStyle} placeholder="0" data-testid={`ak-${s.key}-alis-iscilik`} />
                    </td>
                    <td style={{ padding: 4 }}>
                      <input type="text" inputMode="decimal" value={c.satis_iscilik ?? ""} onChange={e => onUpdateField(s.key, "satis_iscilik", e.target.value)} style={inputStyle} placeholder="0" data-testid={`ak-${s.key}-satis-iscilik`} />
                    </td>
                  </>
                )}
                <td style={{ padding: 4 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <button type="button" data-testid={`ak-${s.key}-alis-marj-neg`}
                      onClick={() => onUpdateField(s.key, "alis_marj", String(-(parseFloat(c.alis_marj) || 0)))}
                      style={{ flexShrink: 0, width: 26, height: 30, border: "1px solid #cbd5e1", borderRadius: 6, background: "#f1f5f9", color: "#334155", fontWeight: 800, fontSize: 15, cursor: "pointer", lineHeight: 1 }}>±</button>
                    <input type="text" inputMode="decimal" value={c.alis_marj ?? ""} onChange={e => onUpdateField(s.key, "alis_marj", e.target.value)} style={inputStyle} data-testid={`ak-${s.key}-alis-marj`} />
                  </div>
                </td>
                <td style={{ padding: 4 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <button type="button" data-testid={`ak-${s.key}-satis-marj-neg`}
                      onClick={() => onUpdateField(s.key, "satis_marj", String(-(parseFloat(c.satis_marj) || 0)))}
                      style={{ flexShrink: 0, width: 26, height: 30, border: "1px solid #cbd5e1", borderRadius: 6, background: "#f1f5f9", color: "#334155", fontWeight: 800, fontSize: 15, cursor: "pointer", lineHeight: 1 }}>±</button>
                    <input type="text" inputMode="decimal" value={c.satis_marj ?? ""} onChange={e => onUpdateField(s.key, "satis_marj", e.target.value)} style={inputStyle} data-testid={`ak-${s.key}-satis-marj`} />
                  </div>
                </td>
                <td style={{ padding: "8px 4px", textAlign: "center" }}>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 3, padding: "2px 6px", borderRadius: 3, background: `${status.color}22`, color: status.color, fontSize: 10, fontWeight: 600 }}>
                    {status.icon} {(c.last_change_pct || 0) > 0 ? fmtPct(c.last_change_pct) : status.label}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>

    <button onClick={onSave} data-testid="ak-save-carpan-btn"
      style={{ marginTop: 12, padding: "11px 22px", background: "#DA9F54", color: "#000", border: "none", borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
      💾 Çarpanları Kaydet
    </button>
  </div>
);

export default SarrafiyeCarpanTable;
